import * as actionTypes from './actionTypes';

export const nextStep = () => {
  return {
    type : actionTypes.ORG_CHART_NEXT_STEP,
    val : null
  }
}

export const goBack = () => {
  return {
    type : actionTypes.ORG_CHART_PREVIOUS_STEP,
    val : null
  }
}

export const saveAllColumnsAndData = (columns,data,file) => {
  console.log('reducers--', columns,data,file)
  return {
    type : actionTypes.ORG_CHART_STORE_ALL_COLUMNS_AND_DATA,
    val : {
      columns : columns,
      data : data,
      file: file
    }
  }
}

export const saveOrgChartMatchedColumn = (val) => {
  return {
    type : actionTypes.ORG_CHART_STORE_MATCHED_COLUMN,
    val : val
  }
}



export const saveAllOffices = (allOffices) => {
  return {
    type : actionTypes.ORG_CHART_STORE_ALL_OFFICES,
    val : allOffices
  }
}

export const saveOfficeHierarchy = (hierarchy) => {
  return {
    type : actionTypes.ORG_CHART_STORE_OFFICE_HIERARCHY,
    val : hierarchy
  }
}
// manageNewOffices
export const manageNewOffices = (offices) => {
  console.log(offices)
  return {
    type : actionTypes.MANAGE_NEW_OFFICES,
    val : offices
  }
}

export const saveHierarchyChanges = (hierarchy)=>{
  return {
    type: actionTypes.SAVE_HIERARCHY_CHANGES,
    val: hierarchy
  }
}


export const saveUpdatedOffices = (updatedOffices) =>{
  console.log(updatedOffices)
  return {
    type: actionTypes.SAVE_UPDATED_OFFICES,
    val: updatedOffices
  }
}

export const saveDisabledOffices = (disabledOffices) =>{
  return {
    type: actionTypes.SAVE_DISABLED_OFFICES,
    val: disabledOffices
  }
}

export const saveAllOfficeMaterialPaths = (paths) => {
  return {
    type : actionTypes.ORG_CHART_STORE_MATERIAL_PATHS,
    val : paths
  }
}

export const flaggedAdminOfficeSelected = (office) => {
  return {
    type : actionTypes.ORG_CHART_FLAGGED_ADMIN_OFFICE_SELECTED,
    val : office
  }
}

export const saveAllOfficeMaterialPathsWithInvitation = (offices) => {
  return {
    type : actionTypes.ORG_CHART_STORE_MATERIAL_PATHS_WITH_INVITATION,
    val : offices
  }
}

// export const searchOfficeByName = (offices) => {
//   return {
//     type : actionTypes.ORG_CHART_SEARCH_OFFICE,
//     val : offices
//   }
// }